import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { useNavigate } from "react-router-dom";
import { Message } from "../../../components/message";
import {
  mobileVersionsList,
  updateMobileVersion,
} from "../../../services/api/admin";
import { customStylesAcc, selectTheme } from "../../../Utils/common";
import Select from "react-select";
import { FaApple, FaAndroid } from "react-icons/fa";
import {
  checkPermission,
  permissionsConfig,
} from "../AdminPermission/PermissionChecker";

const MobileVersions = () => {
  const navigate = useNavigate();
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const [selectedModuleIndex, setSelectedModuleIndex] = useState("1");
  const platformList = [
    { label: "IOS", value: "1" },
    { label: "Android", value: "2" },
  ];

  const priorityList = [
    { label: "Force update", value: "0" },
    { label: "Minor update", value: "1" },
    { label: "Ignore", value: "2" },
    { label: "Up-to-date", value: "3" },
  ];

  const [platform, setPlatform] = useState(null);
  const [versionName, setVersionName] = useState("");
  const [priority, setPriority] = useState("");
  const [dialogMessageEn, setDialogMessageEn] = useState("");
  const [dialogMessageHi, setDialogMessageHi] = useState("");

  const [prioritySelectErr, setPrioritySelectErr] = useState("");
  const [versionNameError, setVersionNameError] = useState("");
  const [dialogMessageEnErr, setDialogMessageEnErr] = useState("");
  const [dialogMessageHiErr, setDialogMessageHiErr] = useState("");
  const [mobileVersionData, setMobileVersionData] = useState();

  const grantPermissionForEditConfigurations = checkPermission(
    permissionsConfig.editConfiguration.role,
    permissionsConfig.editConfiguration.action,
    permissionsConfig.editConfiguration.type
  );

  useEffect(() => {
    versionDataByPlatform(platformList[0]);
  }, []);

  const versionDataByPlatform = async (item) => {
    try {
      const filterType = item != undefined ? item : platformList[0];
      const dataList = await mobileVersionsList();
      if (dataList?.status == 200) {
        const versionData = dataList?.data.data?.find(
          (x) => x.platform == filterType?.value
        );
        setMobileVersionData(versionData);
        setPlatform(platformList.find((x) => x.value == versionData?.platform));
        setPrioritySelectErr("");
        setVersionNameError("");
        setDialogMessageEnErr("");
        setDialogMessageHiErr("");
        setVersionName(versionData?.version_name || "");
        setPriority(
          priorityList.find((x) => x.value == versionData?.priority) || ""
        );
        setDialogMessageEn(versionData?.dialog_message_en || "");
        setDialogMessageHi(versionData?.dialog_message_hi || "");
      } else {
        setApiMessage({ type: "error", message: dataList?.message });
      }
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const handleInput = async (e) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    if (name == "version_name") {
      setVersionName(value);
      if (!value) {
        setVersionNameError("Version name is required");
      } else {
        setVersionNameError("");
      }
    } else if (name == "diloag_message_en") {
      setDialogMessageEn(value);
      if (!value) {
        setDialogMessageEnErr("English dialog message is required");
      } else {
        setDialogMessageEnErr("");
      }
    } else if (name == "diloag_message_hi") {
      setDialogMessageHi(value);
      if (!value) {
        setDialogMessageHiErr("Hindi dialog message is required");
      } else {
        setDialogMessageHiErr("");
      }
    }

    // Restore cursor position after state update
    setTimeout(() => {
      if (e.target) {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 0);

    // Validate input
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    if (name === "version_name") {
      if (!value.trim()) {
        setVersionNameError("Please enter the version name");
        return false;
      } else {
        setVersionNameError("");
      }
    } else if (name === "diloag_message_en") {
      if (!value.trim()) {
        setDialogMessageEnErr("Please enter the English dialog message");
        return false;
      } else {
        setDialogMessageEnErr("");
      }
    } else if (name === "diloag_message_hi") {
      if (!value.trim()) {
        setDialogMessageHiErr("Please enter the Hindi dialog message");
        return false;
      } else {
        setDialogMessageHiErr("");
      }
    } else if (name === "priority") {
      if (!value) {
        setPrioritySelectErr("Please select a priority");
        return false;
      } else {
        setPrioritySelectErr("");
      }
    }

    return true;
  };

  const validateAll = () => {
    let isValid = true;

    if (!versionName.trim()) {
      setVersionNameError("Please enter the version name");
      isValid = false;
    } else {
      setVersionNameError("");
    }

    if (!dialogMessageEn.trim()) {
      setDialogMessageEnErr("Please enter the English dialog message");
      isValid = false;
    } else {
      setDialogMessageEnErr("");
    }

    if (!dialogMessageHi.trim()) {
      setDialogMessageHiErr("Please enter the Hindi dialog message");
      isValid = false;
    } else {
      setDialogMessageHiErr("");
    }

    if (!priority?.value) {
      setPrioritySelectErr("Please select a priority");
      isValid = false;
    } else {
      setPrioritySelectErr("");
    }

    return isValid;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (validateAll()) {
        const formData = new FormData();
        formData.append("id", mobileVersionData?.id);
        formData.append("platform", parseInt(platform?.value));
        formData.append("version_name", versionName);
        formData.append("priority", parseInt(priority?.value));
        formData.append("dialog_message_en", dialogMessageEn);
        formData.append("dialog_message_hi", dialogMessageHi);

        const dataUpdate = await updateMobileVersion(formData);
        if (dataUpdate?.status === 200) {
          await versionDataByPlatform(platform);
          setApiMessage({ type: "success", message: dataUpdate?.message });
        } else {
          setApiMessage({ type: "error", message: dataUpdate?.message });
        }
      }
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <b onClick={() => navigate("/admin/")}>Home /</b>
            <span> Mobile Versions</span>
          </div>
        </div>
        {apiMessage && (
          <Message
            apiMessage={apiMessage}
            setApiMessage={setApiMessage}
          ></Message>
        )}
        <div className="aod-inner">
          <div className="content-wrapper" id="sms-page">
            <div className="flex-grow-1 container-p-y">
              <h4 className="mb-4">Mobile Versions</h4>
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4">
                  <div className="card mb-4 border-0">
                    <h5 className="card-header">List</h5>
                    <ul className="template-list">
                      {platformList?.map((item, index) => (
                        <a key={index}>
                          <li
                            className={`odd ${
                              selectedModuleIndex === item.value ? "active" : ""
                            }`}
                            id={`v-pills-${item.label}-tab`}
                            aria-selected={selectedModuleIndex == item.value}
                            onClick={() => {
                              setSelectedModuleIndex(item.value);
                              versionDataByPlatform(item);
                            }}
                          >
                            {item?.label === "IOS" ? (
                              <FaApple className="me-2 fs-6"></FaApple>
                            ) : (
                              <FaAndroid className="me-2 fs-5"></FaAndroid>
                            )}{" "}
                            {item.label}
                          </li>
                        </a>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8 col-md-8">
                  <div className="card mb-4 border-0">
                    <form className="card-body admin-role-form">
                      <div className="col-md-12">
                        <label className="form-label">Version</label>
                        <input
                          type="text"
                          id="map-provider"
                          className="form-control"
                          maxLength={60}
                          placeholder=""
                          name="version_name"
                          value={versionName || ""}
                          onChange={handleInput}
                        />
                        {versionNameError && (
                          <p className="validate-error">{versionNameError}</p>
                        )}
                      </div>
                      <div className="col-md-12 mt-2">
                        <label className="form-label">Priority</label>
                        <Select
                          styles={customStylesAcc}
                          theme={selectTheme}
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          className="menu_open_select"
                          classNamePrefix="ad-menu_open_select_class"
                          aria-label="Default select example"
                          value={priority}
                          options={priorityList}
                          onChange={(select) => {
                            setPriority(select);
                            setPrioritySelectErr("");
                          }}
                          placeholder="Select Priority"
                        />
                        {prioritySelectErr && (
                          <p className="validate-error">{prioritySelectErr}</p>
                        )}
                      </div>
                      <div className="col-md-12 mt-2">
                        <label className="form-label">
                          English Dialog Message
                        </label>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder="Add here"
                          rows="3"
                          spellCheck="false"
                          name="diloag_message_en"
                          value={dialogMessageEn || ""}
                          onChange={handleInput}
                        ></textarea>
                        {dialogMessageEnErr && (
                          <p className="validate-error">{dialogMessageEnErr}</p>
                        )}
                      </div>
                      <div className="col-md-12 mt-2">
                        <label className="form-label">
                          Hindi Dialog Message
                        </label>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder="Add here"
                          rows="3"
                          spellCheck="false"
                          name="diloag_message_hi"
                          value={dialogMessageHi || ""}
                          onChange={handleInput}
                        ></textarea>
                        {dialogMessageHiErr && (
                          <p className="validate-error">{dialogMessageHiErr}</p>
                        )}
                      </div>
                      {grantPermissionForEditConfigurations ? (
                        <div className="row ad-cat-row mt-3">
                          <div className=" update-btns-block">
                            <button
                              onClick={(e) => handleSubmit(e)}
                              className="me-3"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="content-backdrop fade"></div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default MobileVersions;
